const smallStarSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="14.398px" height="14.286px" viewBox="0 0 14.398 14.286" enable-background="new 0 0 14.398 14.286" xml:space="preserve">
<path fill="#FFFFFF" d="M14.398,7.199c0-0.453-0.231-0.8-0.688-1.028L9.938,4.457L8.227,0.683C8.112,0.229,7.652,0,7.199,0
	C6.738,0,6.4,0.346,6.169,0.683l-1.71,3.661L0.682,6.059C0.224,6.171,0,6.63,0,7.088c0,0.456,0.224,0.798,0.682,1.028L4.459,9.83
	l1.71,3.769c0.112,0.455,0.569,0.688,1.03,0.688c0.453,0,0.913-0.347,0.913-0.574l1.712-3.771l3.772-1.713
	C14.057,8,14.281,7.544,14.398,7.199"/>
</svg>
`;

export default smallStarSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/smallStarSVG.js